import React from "react";
import styled from "styled-components";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowDown, faArrowUp } from '@fortawesome/pro-solid-svg-icons'
import {formatNumber} from "./Format";


const UpArrow = styled(FontAwesomeIcon)`
  color: green
`

const DownArrow = styled(FontAwesomeIcon)`
  color: red
`

export const TendencyPts = ({value, refValue}) => {
  const diff = (value-refValue)
  const formattedValue = formatNumber(Math.abs(diff), {digits: 2})
  if ( diff < 0 ) {
    return (<><DownArrow icon={faArrowDown} /> {formattedValue}pts</> )
  } else if ( diff > 0 ) {
    return (<><UpArrow icon={faArrowUp} /> {formattedValue}pts</> )
  } else {
    return ( ("-") )
  }
}

export const Tendency = ({value, refValue}) => {
  if ( ! refValue || refValue == 0 ) return ( ("-") )
  const ratio = (value-refValue)/refValue * 100
  const formattedValue = formatNumber(Math.abs(ratio), {digits: 2})
  if ( ratio < 0 ) {
    return (<><DownArrow icon={faArrowDown} /> {formattedValue}%</> )
  } else if ( ratio > 0 ) {
    return (<><UpArrow icon={faArrowUp} /> {formattedValue}%</> )
  } else {
    return ( ("-") )
  }
}
